import styled, { css } from "styled-components";
import { SM_MEDIA_QUERY_RULE } from "../../../../config";

export const ReferenceElement = {
  Wrapper: styled.div`
    color: var(--comanage-purple);
    width: 100%;
    /* border-bottom: solid 1px white; */
    cursor: pointer;
    display: flex;
    flex-direction: row;
    position: relative;
    border-bottom-left-radius: 10px;
    border-top-right-radius: 10px;
    border-bottom-right-radius: 10px;
    /* border-right: solid 1px white;
      border-left: solid 1px white; */
    align-items: center;
    justify-content: center;
    ${({ toggle }) =>
      toggle
        ? css`
            background-color: rgba(24, 129, 167, 0);
          `
        : css`
            /* background-color: rgba(28, 194, 203, 0.22); */
            background-color: rgba(106, 80, 161, 0.12);
          `}
    @media (${SM_MEDIA_QUERY_RULE}) {
      margin-bottom: 5px;
    }
  `,
  Name: styled.div`
    min-width: 75%;
    max-width: 75%;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    word-wrap: break-word;
    word-break: break-all;
  `,
  Pages: styled.div`
    border-left: solid 1px rgba(24, 129, 167, 0.53);
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    text-align: center;
    min-height: 40px;
    width: 20%;
    flex-wrap: wrap;
  `,
  Page: styled.div``,
  Link: styled.div`
    min-width: 20px;
    min-height: 20px;
    max-width: 20px;
    max-height: 20px;
    background-color: var(--comanage-purple);
    border-radius: 100%;
    color: #4ebb76;
    text-align: center;
    cursor: pointer;
    margin-right: 5px;
    margin-left: 5px;
  `,
  DetailList: styled.div`
    border-bottom: solid 1px rgba(24, 129, 167, 0.53);
    padding-bottom: 5px;
    /* border-left: solid 1px red;
    border-right: solid 1px red; */
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
  `,
  DetailWrapper: styled.div`
    display: flex;
    flex-direction: row;
    color: var(--comanage-purple);
    font-weight: lighter;
    background-color: rgba(106, 80, 161, 0.18);
  `,
  DetailPage: styled.div`
    max-width: 20%;
    min-width: 20%;
    display: flex;
    align-items: center;
    justify-content: center;
  `,
  DetailText: styled.div`
    max-width: 80%;
    min-width: 80%;
  `,
  LinkWrapper: styled.div`
    @media (${SM_MEDIA_QUERY_RULE}) {
      flex-direction: column;
      gap: 5px;
    }
    display: flex;
    flex-direction: row;
  `,
};
export const ReferenceDocName = styled.div`
  all: unset;
`;
